import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { WorkerService } from '@/api/worker';
import { Loading } from '@/components/Loading';
import WorkerDetailModal from '@/components/worker/WorkerDetailModal';
import WorkerQCPanel from '@/components/worker/WorkerQCPanel';
import WorkerProjectPanel from '@/components/worker/WorkerProjectPanel'; 

export const WorkerDashboard = () => {
  const [date, setDate] = useState(() => {
    const currentDate = new Date();

    return `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1,
    ).padStart(2, '0')}`;
  });

  const [appliedDate, setAppliedDate] = useState(date);

  const [selectedQC, setSelectedQC] = useState<
    Awaited<ReturnType<typeof WorkerService.getDashboard>>['qc'][number] | null
  >(null);

  const [selectedProject, setSelectedProject] = useState<
    Awaited<
      ReturnType<typeof WorkerService.getDashboard>
    >['projects'][number] | null
  >(null);

  const { data, isLoading, isError } = useQuery({
    queryKey: ['worker-dashboard', appliedDate],
    queryFn: () => WorkerService.getDashboard(appliedDate),
  });

  const handleApply = () => {
    setAppliedDate(date);
  };

  const handleQCClick = (
    qc: Awaited<ReturnType<typeof WorkerService.getDashboard>>['qc'][number],
  ) => {
    setSelectedQC(qc);
    setSelectedProject(null);
  };


  const handleProjectClick = (
    project: Awaited<
      ReturnType<typeof WorkerService.getDashboard>
    >['projects'][number],
  ) => {
    setSelectedProject(project);
    setSelectedQC(null);
  };

  const handleCloseModal = () => {
    setSelectedQC(null);
    setSelectedProject(null);
  };

  return (
    <div className="flex min-h-screen flex-col overflow-hidden bg-slate-200 p-4 sm:p-5">
      <div className="flex shrink-0 flex-wrap items-center justify-between gap-3">
        <h1 className="text-lg font-semibold">Worker Dashboard</h1>

        <div className="flex flex-wrap items-center gap-2">
          <label htmlFor="worker-date" className="text-sm font-medium">
            Periode
          </label>

          <input
            id="worker-date"
            type="month"
            value={date}
            onChange={event => setDate(event.target.value)}
            className="rounded-md border bg-white px-3 py-2 text-sm"
          />

          <button
            type="button"
            onClick={handleApply}
            disabled={date === appliedDate || isLoading}
            className="rounded-md border bg-slate-900 px-4 py-2 text-sm font-medium text-white disabled:cursor-not-allowed disabled:opacity-50"
          >
            Apply
          </button>
        </div>
      </div>

      <div className="mt-4 min-h-0 flex-1">
        {isLoading && <Loading />}

        {isError && !isLoading && (
          <div className="rounded-lg border bg-white p-6">
            <p>Data dashboard tidak tersedia.</p>
          </div>
        )}

        {data && !isLoading && (
          <div className="flex h-full min-h-0 flex-col gap-4">
            <WorkerQCPanel data={data.qc} onQCClick={handleQCClick} />

            <WorkerProjectPanel
              data={data.projects}
              onProjectClick={handleProjectClick}
            />
          </div>
        )}
      </div>

      <WorkerDetailModal
        selectedQC={selectedQC}
        selectedProject={selectedProject}
        onClose={handleCloseModal}
        period={data?.period ?? appliedDate}
      />
    </div>
  );
};